import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import SportsCategories from './components/SportsCategories';
import SportsNews from './components/SportsNews';
import LiveMatches from './components/LiveMatches';
// import PopularReplays from './components/PopularReplays'; // 已删除热门回放模块
import AdBanner from './components/AdBanner';
import BannerAd from '../../components/feature/BannerAd';
import SidebarAd from '../../components/feature/SidebarAd';
import FloatingAppDownload from './components/FloatingAppDownload';
import { useState, useEffect } from 'react';
import { configInfo,getadvertiseList } from '@/services/setting';
import { useDispatch,useSelector } from 'react-redux';
import { setConfigInfo } from '@/store/settingsSlice';
import { getLiveCategorys, getLiveList } from '../../services/live';
import { getNewsList } from '@/services/news';

export default function Home() {
  const [selectedSport, setSelectedSport] = useState<any>({ id: 0, name: '全部' });
  const [mobileModuleOrder, setMobileModuleOrder] = useState<'news-first' | 'live-first'>('live-first');
  const [liveCategories, setLiveCategories] = useState<any[]>([]);
  const [liveList, setLiveList] = useState<any[]>([]);
  const [newsList, setNewsList] = useState<any[]>([]);
   const [adList, setAdList] = useState<any[]>([]);
  const dispatch = useDispatch();

  const settingConfigInfo = useSelector((state: any) => state.settings.configInfo);
  console.log('settingConfigInfo:', settingConfigInfo);
  // 切换移动端模块顺序
  const toggleMobileOrder = () => {
    setMobileModuleOrder(prev => prev === 'live-first' ? 'news-first' : 'live-first');
  };

  useEffect(() => {
    // configInfo().then((res: any) => {
    //   if (res && res.status === 1 && res.data) {
    //     dispatch(setConfigInfo(res.data));
    //   }
    //   console.log('configInfo:', res);
    // });
    // 获取广告列表
    getadvertiseList({ type: '1' }).then((res: any) => {
      if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
        setAdList(res.data.lists);
      }
    });
    
    // 获取直播分类
    getLiveCategorys().then((res: any) => {
      if (res && res.status === 1 && Array.isArray(res.data)) {
        setLiveCategories(res.data);
      }
    });

    
    // 获取新闻列表
    getNewsList({ category_id: '',keyword: '' }).then((res: any) => {
      if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
        setNewsList(res.data.lists);
      }
    });
  }, []);

  // 防止未使用变量警告
  // liveCategories, liveList 可传递给子组件或用于渲染

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main>
        <Hero />
        
        {/* 体育分类 - 横向小图标 */}
        <SportsCategories
          categories={liveCategories}
          imageServer={settingConfigInfo?.image_server}
          onCategorySelect={setSelectedSport}
          selectedCategory={selectedSport}
        />
        
        {/* 移动端模块顺序切换按钮 */}
        <div className="block lg:hidden bg-white border-b border-gray-100 py-3">
          <div className="container mx-auto px-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center text-sm text-gray-600">
                <i className="ri-layout-line mr-2"></i>
                内容显示顺序
              </div>
              <button
                onClick={toggleMobileOrder}
                className="flex items-center bg-gray-100 hover:bg-gray-200 rounded-full p-1 transition-colors"
              >
                <div className={`flex items-center px-3 py-1.5 rounded-full transition-all text-xs font-medium ${
                  mobileModuleOrder === 'news-first' 
                    ? 'bg-green-500 text-white' 
                    : 'text-gray-600'
                }`}>
                  <i className="ri-newspaper-line mr-1"></i>
                  新闻优先
                </div>
                <div className={`flex items-center px-3 py-1.5 rounded-full transition-all text-xs font-medium ${
                  mobileModuleOrder === 'live-first' 
                    ? 'bg-red-500 text-white' 
                    : 'text-gray-600'
                }`}>
                  <i className="ri-live-line mr-1"></i>
                  直播优先
                </div>
              </button>
            </div>
          </div>
        </div>
        
        {/* 体育新闻和直播中心的响应式布局 */}
        <section className="py-8 md:py-12 bg-gray-50" data-live-section>
          <div className="container mx-auto px-4">
            {/* 移动端垂直布局，桌面端水平布局 */}
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
              {/* 移动端：根据用户选择显示顺序 */}
              {mobileModuleOrder === 'news-first' ? (
                <>
                  {/* 移动端：新闻优先 */}
                  <div className="block lg:hidden w-full mb-8">
                    <SportsNews newsList={newsList} selectedSport={selectedSport} />
                  </div>
                  <div className="block lg:hidden w-full mb-8">
                    <LiveMatches liveList={liveList} selectedSport={selectedSport} />
                  </div>
                </>
              ) : (
                <>
                  {/* 移动端：直播优先 */}
                  <div className="block lg:hidden w-full mb-8">
                    <LiveMatches liveList={liveList} selectedSport={selectedSport} />
                  </div>
                  <div className="block lg:hidden w-full mb-8">
                    <SportsNews newsList={newsList} selectedSport={selectedSport} />
                  </div>
                </>
              )}
              
              {/* 桌面端：体育新闻在左 */}
              <div className="hidden lg:block">
                <SportsNews newsList={newsList} selectedSport={selectedSport} />
              </div>
              {/* 桌面端：直播中心在中间 */}
              <div className="hidden lg:block flex-1">
                <LiveMatches selectedSport={selectedSport} liveList={liveList}/>
              </div>
              
              {/* 右侧 - 侧边栏广告 - 只在桌面端显示 */}
              <div className="hidden lg:block w-64 flex-shrink-0">
                <SidebarAd adList={adList}/>
              </div>
            </div>
          </div>
        </section>

        {/* 已删除精彩回放区域 */}

        {/* 底部横幅广告 */}
        <section className="py-4 md:py-6 bg-gray-50">
          <div className="container mx-auto px-4">
            <BannerAd size="large" position="bottom" />
          </div>
        </section>
        
        {/* 移动端额外广告区域 */}
        <div className="block lg:hidden">
          <AdBanner />
        </div>
      </main>
      
      <Footer />
      
      {/* 悬浮APP下载 */}
      <FloatingAppDownload />
    </div>
  );
}